module.exports = __webpack_public_path__ + "assets/img/Contact_bgimg.42d71867.png";